<script lang="ts">
    import Fa from 'svelte-fa'
    import { faBell, faCheck, faCheckDouble } from '@fortawesome/free-solid-svg-icons'
    import Popover from './popover.svelte'
    import Zgrid from './z/zgrid.svelte'
    import { GridBadge, GridBadgeClassEnum, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from './z/zgrid'
    import { notifications } from './stores'
    import type { AppNotification } from '../../modules/notificationsApi/notification'

    let show = false
    let grid: GridClass = new GridClass()

    $: unreadCount = ($notifications || []).filter((n) => !n.readAt).length
    $: loadGrid($notifications || [])

    function loadGrid(list: AppNotification[]) {
        grid = new GridClass()
        grid.title = 'Notificações'
        grid.showActs = false
        grid.showFilter = false
        grid.showFilter = false
        grid.fontSize = '14px'
        if (list.some((n) => !n.readAt)) {
            grid.acts.push(new GridButton({ label: 'Marcar todas como lidas', icon: faCheckDouble, callback: markAllRead }))
        }
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge, size: 1 }))
        grid.cols.push(new GridCol({ content: 'Notificação', type: GridColTypeEnum.string }))
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime, size: 2 }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button, size: 1 }))

        for (const item of list) {
            const line = new GridLine()
            line.slots.push({
                content: new GridBadge({
                    label: item.readAt ? 'lida' : 'não lida',
                    class: item.readAt ? GridBadgeClassEnum.badge_disabled : GridBadgeClassEnum.badge_blue,
                }),
            })
            line.slots.push({ content: item.title + ' — ' + item.message })
            line.slots.push({ content: item.createdAt })
            const buttons = []
            if (!item.readAt) {
                buttons.push(new GridButton({ icon: faCheck, label: '', title: 'Marcar como lida', callback: () => markRead(item.id) }))
            }
            line.slots.push({ content: buttons })
            grid.lines.push(line)
        }
    }

    async function markRead(id: string) {
        try {
            await window.api.notifications.markRead(id)
            notifications.update((list) => list.map((n) => (n.id === id ? { ...n, readAt: new Date() } : n)))
        } catch (error) {
            window.error(error)
        }
    }

    async function markAllRead() {
        try {
            await window.api.notifications.markAllRead()
            notifications.update((list) => list.map((n) => ({ ...n, readAt: new Date() })))
        } catch (error) {
            window.error(error)
        }
    }
</script>

<a class="square menu-icon notifications-bell" on:click={() => (show = true)}>
    <Fa icon={faBell} />
    {#if unreadCount > 0}
        <span class="notifications-bell-count">{unreadCount > 99 ? '99+' : unreadCount}</span>
    {/if}
</a>

{#if show}
    <Popover on:close={() => (show = false)} width="1200px" title="Notificações" padding="0px">
        <div class="m-3">
            <Zgrid {grid} class="" />
        </div>
    </Popover>
{/if}

<style>
    .notifications-bell {
        position: relative;
        color: rgb(var(--menu-color));
        margin: 7px 6px 6px 6px;
        display: flex;
    }
    .notifications-bell-count {
        position: absolute;
        top: 2px;
        right: 2px;
        min-width: 15px;
        padding: 2px 4px;
        border-radius: 50%;
        background: #dc3545;
        color: #fff;
        font-size: 10px;
        font-weight: 600;
        line-height: 1;
        text-align: center;
    }
</style>
